import axios from '@/plugins/axios.js';

/**
 * Repricing graded late work after a due date moves later. The server decides whether the
 * date is an extension: an earlier or unchanged date answers zero eligible submissions.
 */
const activityDueDateRecalculationService = {
    async preview(activityId, dueAt) {
        const response = await axios.get(`/api/activities/${activityId}/due-date-recalculation-preview`, {
            params: { due_at: dueAt },
        });

        return response.data.data;
    },

    // A lost response can follow a committed write, so the transport never replays this call.
    async run(activityId, dueAt) {
        const response = await axios.post(
            `/api/activities/${activityId}/due-date-recalculation`,
            { due_at: dueAt },
            { retry: false }
        );

        return response.data.data;
    },
};

export default activityDueDateRecalculationService;
